/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { FC, useEffect, useState } from 'react';
import moment from 'moment';
import { translate } from 'translations';
import { Divider, Icon } from 'learning-panel-components';
import { NotificationTypes } from './notificationTypes';
import styles from './notification.module.scss';

const Notification: FC<NotificationTypes> = (props: NotificationTypes) => {
    const { sentDate, title, content, onClose, refFunction } = props;

    return (
        <div className={styles['open-notification']} ref={refFunction}>
            <div className={styles.wrapper}>
                <div className={styles.top}>
                    <div className={styles.right}>
                        <Icon name="cbLogo" />
                        <div>{translate('CodebashingNews')}</div>
                        <div className={styles.divider}>
                            <Divider color="rgba(255, 255, 255, 0.7)" />
                        </div>
                        <div className={styles.date}>{moment(sentDate).format('LLL')}</div>
                    </div>
                    <Icon name="exitIcon" className={styles['exit-icon']} onClick={() => onClose()} />
                </div>
                <hr />
                <div className={styles['content-wrapper']}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.content}>
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Notification;
